import { RowAction } from "@tiny/components/src/ListItemRow/ListItemRow.types";
import { SegmentView } from "@tiny/api";
import { ChipColor } from "@tiny/components/src/Chip/Chip.types";
import {
  ActionTimeInfo,
  TimeAction,
} from "@tiny/components/src/ItemActionTimeInfo/ItemActionTimeInfo.types";
export const dateFormat = "dd MMM, yy - hh:mm a";

export function getTimeActionsInfo(
  mdUp: boolean,
  audience: SegmentView,
  sortAction?: TimeAction
): ActionTimeInfo[] {
  const createdDate: ActionTimeInfo = {
    action: "Created",
    timestamp: audience.createdAt,
  };
  const modifiedDate: ActionTimeInfo = {
    action: "Modified",
    timestamp: audience.updatedAt,
  };
  const actions: ActionTimeInfo[] = [];
  if (sortAction === "Modified") {
    actions.push(modifiedDate);
    mdUp && actions.push(createdDate);
  } else if (sortAction === "Created") {
    actions.push(createdDate);
    mdUp && actions.push(modifiedDate);
  } else {
    actions.push(createdDate);
  }

  return actions;
}

export function toChipText(segmentType?: string): string | undefined {
  switch (segmentType) {
    case "INTEGRATION":
      return "Integration";
    case "UPLOAD":
      return "Manual";
    default:
      return undefined;
  }
}

export function toChipColor(segmentType?: string): ChipColor | undefined {
  switch (segmentType) {
    case "INTEGRATION":
      return "blue";
    case "UPLOAD":
      return "purple";
    default:
      return undefined;
  }
}

export function getRowActions(): RowAction[] {
  return [];
}
